module.exports = __webpack_public_path__ + "static/img/icon-date.0ef10f6c.svg";